export default {"src":"https://assets.madeeasy.in/prod/_next/static/media/location.4d3a9aaf.svg","height":18,"width":16,"blurWidth":0,"blurHeight":0};